import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

export const policyTemplateGroupRequirementsApi = createApi({
  reducerPath: 'policyTemplateGroupRequirements',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getGroupRequirementsPreview: builder.query({
      query: ({ templateId, customerId }) => ({
        url: `/secure/policy/template/${templateId}/group-requirements/preview`,
        params: { customerId },
      }),
    }),
  }),
})

export const { useGetGroupRequirementsPreviewQuery, useLazyGetGroupRequirementsPreviewQuery } =
  policyTemplateGroupRequirementsApi

export const useGroupRequirementsPreview = ({ templateId }, options = {}) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetGroupRequirementsPreviewQuery(
    { templateId, customerId },
    { ...options, skip: options.skip || !templateId || !customerId },
  )
}
